module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/19mill-inactive-11fbc3e8ae681c01f660a38ddd616225.png";